// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8242126e","453":"98d77d04","455":"f085d1cb"}[chunkId] + ".chunk.js";
};